import {
  Box,
  Flex,
  Text,
  config as cssConfig,
  styled,
  textEllipsis,
  useTheme,
} from "@100mslive/react-ui";
import { Fragment, useCallback, useContext, useEffect, useMemo } from "react";
import {
  selectDominantSpeaker,
  selectIsConnectedToRoom,
  useHMSStore,
} from "@100mslive/react-sdk";

import { LANG_CODES } from "../../lang";
import { LiveHodoContext } from "../../contexts/LiveHodoContext";
import { VolumeOneIcon } from "@100mslive/react-icons";
import { isStreamingKit } from "../../common/utils";
import { useLogo } from "../AppData/useUISettings";
import { useMedia } from "react-use";
import { useTranslation } from "react-i18next";

export const SpeakerTag = () => {
  const dominantSpeaker = useHMSStore(selectDominantSpeaker);

  return dominantSpeaker && dominantSpeaker.name ? (
    <Flex
      align="center"
      justify="center"
      css={{ flex: "1 1 0", color: "$textPrimary", "@md": { display: "none" } }}
    >
      <VolumeOneIcon />
      <Text
        variant="md"
        css={{ ...textEllipsis(200), ml: "$2" }}
        title={dominantSpeaker.name}
      >
        {dominantSpeaker.name}
      </Text>
    </Flex>
  ) : (
    <></>
  );
};

const LogoImg = styled("img", {
  maxHeight: "$18",
  p: "$2",
  w: "auto",
  "@md": {
    maxHeight: "$14",
  },
});

export const Logo = () => {
  const { t, i18n } = useTranslation();

  const {
    stateCtx: { circleRoomDetail },
  } = useContext(LiveHodoContext);
  const { themeType } = useTheme();
  const logo = useLogo();
  const isMobile = useMedia(cssConfig.media.md);
  const isConnected = useHMSStore(selectIsConnectedToRoom);

  // useEffect(() => {
  //   console.log(circleRoomDetail);
  // }, [circleRoomDetail]);

  const circleMultiLang = useMemo(() => {
    // const lang = window.localStorage.getItem("lang") || "vi";
    const langValue = LANG_CODES[i18n.language];
    const langData =
      circleRoomDetail?.circle_language?.find(
        item => item?.Lang === langValue
      ) || {};
    return langData;
  }, [circleRoomDetail, t]);

  // Hide logo for now as there is not enough space
  if (isConnected && isMobile && isStreamingKit()) {
    return null;
  }

  return (
    <Flex align={`center`}>
      {circleRoomDetail &&
      (circleRoomDetail?.logo || circleRoomDetail?.room_logo) ? (
        <LogoImg
          src={circleRoomDetail?.logo || circleRoomDetail?.room_logo}
          alt={circleMultiLang?.name || circleRoomDetail?.name | "Live HODO"}
          width={132}
          height={40}
        />
      ) : (
        <LogoImg
          src={
            logo ||
            (themeType === "dark"
              ? require("../../images/hodologo_256x256.png")
              : require("../../images/hodologo_256x256.png"))
          }
          alt={circleRoomDetail?.name | "Live HODO"}
          width={132}
          height={40}
          css={{ marginRight: 8 }}
        />
      )}
      {circleRoomDetail && (
        <Box>
          <Text variant={`h6`} css={{ ...textEllipsis(960), fontSize: 16 }}>
            {circleMultiLang?.name || circleRoomDetail?.name}
          </Text>
        </Box>
      )}
    </Flex>
  );
};
